import { GovernanceWorkspace } from '@/components/governance/governance-workspace'

export function CommitteePolls() {
  return <GovernanceWorkspace basePath="/committee/polls" />
}
